import { X } from "lucide-react";
import { fmt } from "../lib/constants";

export const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";
export const shortName = (name = "") => {
  const parts = name.split(/\s+/).filter(Boolean);
  return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1][0]}.` : name;
};
const slug = (s) => s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// Venues of one country split by the deal owner who made them clients (whole board view, not only the panel period)
export const OwnerBreakdown = ({ owners, total, period, active, onPick }) => {
  if (!owners?.length) return null;
  const max = owners[0].count;
  return (
    <div data-testid="day-panel-owners" className="shrink-0 rounded-xl border border-panel-border bg-slate-50 px-3 py-2.5">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-1.5">
        <span>By deal owner</span>
        <span className="text-slate-400 normal-case tracking-normal font-medium truncate" data-testid="day-panel-owners-period">· {period}</span>
        <span className="ml-auto num normal-case tracking-normal font-medium shrink-0" data-testid="day-panel-owners-total">{fmt(total)} venues</span>
      </div>
      <div className="grid gap-0.5 max-h-44 overflow-y-auto thin-scroll pr-1">
        {owners.map((o) => {
          const isActive = active === o.name;
          return (
            <button
              key={o.name}
              type="button"
              data-testid={`day-owner-${slug(o.name)}`}
              aria-pressed={isActive}
              onClick={() => onPick(isActive ? null : o.name)}
              title={isActive ? "Show all venues again" : `Show only venues closed by ${o.name}`}
              className={`grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-2.5 rounded-lg px-1.5 py-1 text-left transition-colors ${isActive ? "bg-ink text-page" : "hover:bg-panel"}`}
            >
              <span className={`w-6 h-6 rounded-full text-[10px] font-bold flex items-center justify-center shrink-0 ${isActive ? "bg-page/20 text-page" : "bg-ink/10 text-ink"}`}>{initials(o.name)}</span>
              <span className="min-w-0">
                <span className="flex items-center gap-1.5 text-xs">
                  <span className={`truncate font-semibold ${isActive ? "text-page" : "text-ink"}`}>{o.name}</span>
                  {isActive && <X className="w-3 h-3 shrink-0" />}
                </span>
                <span className={`block h-1.5 rounded-full mt-1 ${isActive ? "bg-panel/20" : "bg-slate-200"}`}>
                  <span className={`block h-full rounded-full ${isActive ? "bg-panel" : "bg-brand"}`} style={{ width: `${Math.max(4, (o.count / max) * 100)}%` }} />
                </span>
              </span>
              <span className="num text-xs text-right whitespace-nowrap" data-testid={`day-owner-${slug(o.name)}-count`}>
                <b>{fmt(o.count)}</b> <span className={isActive ? "text-page/70" : "text-slate-400"}>· {Math.round((o.count / total) * 100)}%</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
